import ButtonV1 from '@jobseeker/lotus/elements/Button';
import type {Props} from '@jobseeker/lotus/elements/Button';
import {useTheme} from '@mui/material';
export {Props};

const Button = ({sx, ...props}: Props) => {
  const theme = useTheme();
  const V2Styles: any = {
    borderRadius: '100px',
    fontWeight: 500,
    borderColor:
      props.color === 'primary'
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
    p: theme.spacing(1, 2),
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    ':hover': {
      borderColor:
        props.color === 'primary'
          ? theme.palette.primary.main
          : theme.palette.secondary.main,
    },
    ...sx,
  };
  if (props.variant === 'outlined') {
    V2Styles['color'] =
      props.color === 'primary'
        ? theme.palette.primary.main
        : theme.palette.secondary.main;
  }
  return (
    <ButtonV1 {...props} sx={V2Styles} disableRipple>
      {props.children}
    </ButtonV1>
  );
};

export default Button;
